import { render, staticRenderFns } from "./SaasModeFunnel.vue?vue&type=template&id=646f8f1a&scoped=true&"
import script from "./SaasModeFunnel.vue?vue&type=script&lang=ts&"
export * from "./SaasModeFunnel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "646f8f1a",
  null
  
)

export default component.exports